import React, { Component } from "react";
import { translate } from "../../../base/i18n/functions";
import { IconSignature } from '../../../base/icons/svg';
import { createRemoteVideoMenuButtonEvent } from "../../../analytics/AnalyticsEvents";
import { sendAnalytics } from "../../../analytics/functions";
import ContextMenuItem from "../../../base/ui/components/web/ContextMenuItem";
class SigntaureButton extends Component {
    constructor(props) {
        super(props);
        this._onClick = this._onClick.bind(this);
    }
    render() {
        const { t } = this.props;
        return (React.createElement(ContextMenuItem, { accessibilityLabel: t('videothumbnail.signature'), className: "kicklink", icon: IconSignature, onClick: this._onClick, text: t('videothumbnail.signature') }));
    }
    _onClick() {
        const { onClick, participantID } = this.props;
        sendAnalytics(createRemoteVideoMenuButtonEvent("Signature.button", {
            participant_id: participantID,
        }));
        if (onClick) {
            onClick();
        }
    }
}
export default translate(SigntaureButton);
